// extracted by mini-css-extract-plugin
export default {"container":"Fleets_container__Op3xf","card":"Fleets_card__yD1aM"};